import React, { FC, useEffect } from 'react';
import { AmpFlagSet } from './amplitude';
import quickMessageConfig from './resources/quickMessageConfig.json';
import { craftCustomActivityMessage } from './messageUtils';
import { Activity } from './types';
import styles from './ReactChat.module.css';
import { ReactTranscript } from './ReactTranscript';
import { getLiveChatService } from './liveChatService';
import { MessageRenderer } from './interfaces/messageRenderer';

const liveChatService = getLiveChatService();

const OfflineChat: FC<{
    featureFlags: AmpFlagSet;
    messageRenderer: MessageRenderer;
}> = ({ featureFlags, messageRenderer }) => {
    useEffect(() => {
        window.parent.postMessage('outage', '*');
    }, []);

    const outageMessage: Activity = craftCustomActivityMessage(
        quickMessageConfig.outage,
        'outage_message'
    );

    return (
        <div className={styles.reactChatContainer}>
            <ReactTranscript
                messages={[outageMessage]}
                sendMessage={() => undefined}
                sendPostBack={() => undefined}
                interactedWithBot={true}
                sendEvent={() => undefined}
                featureFlags={featureFlags}
                modalProperties={undefined}
                setModalProperties={undefined}
                setInputMode={() => undefined}
                liveChatService={liveChatService}
                messageRenderer={messageRenderer}
            />
        </div>
    );
};

export default OfflineChat;
